import { Component, input } from '@angular/core';
import { LineInputs } from '@charts';
import { LineChartComponent } from "../line-chart";

@Component({
  selector: 'ui-tsabt-intensity-chart',
  imports: [LineChartComponent],
  template: ` <ui-line-chart [lineInputs]="lineInputs()" /> `,
})
export class TsabtIntensityChartComponent {
  lineInputs = input.required<LineInputs>();
}
